import React, { useEffect, useRef, useState } from "react";

import retraite from "../../../../../../assets/images/svg/111-rocking-chair.png";
import activite from "../../../../../../assets/images/svg/035-id-card.svg";
import pole from "../../../../../../assets/images/svg/066-job-interview.svg";
import autre from "../../../../../../assets/images/svg/034-clipboard.svg";
import home from "../../../../../../assets/images/svg/069-home.svg";
import university from "../../../../../../assets/images/svg/146-university.png";
import { FormSituationPro } from "./forms/formSituationPro";
import { ProfessionOptions } from "../../../../../../constants/utils/connectionTypes";
export const SituationPro = ({ relocationDeclaration, userId, isLoading, getDeclaration }) => {
	const [editMode, setEditMode] = useState(false);

	return (
		<section className="card mb-sm rounded-bottom-0">
			<div className="card-header pb-0">
				<div className="grid grid-md-2 align-items-center">
					<h2 className="h4 text-uppercase text-secondary font-weight-bolder my-auto">SITUATION PROFESSIONNELLE</h2>
					<div className="grid grid-2 ml-auto align-items-center">
						<button
							type="button"
							className="btn btn-icon p-1 align-middle o-80 o-100--hover mx-auto"
							onClick={() => {
								setEditMode(true);
							}}>
							<i className="eva eva-edit-2-outline align-middle fs-lead"></i>
						</button>
						<div className="custom-control custom-switch mx-auto">
							<input type="checkbox" className="custom-control-input" id="SituationProfSwitchCheckDefault" required="required" defaultChecked={relocationDeclaration?.onBoardingStep > 2} />
							<label className="custom-control-label" htmlFor="SituationProfSwitchCheckDefault">
								Valider
							</label>
						</div>
					</div>
				</div>
				<hr className="mb-0" />
			</div>
			{!editMode ? (
				<div className="card-body grid grid-xl-6">
					<div className={"block flex-row align-items-center" + (relocationDeclaration?.professionalSituation?.includes(ProfessionOptions.active) ? "" : " o-30")}>
						<img className="img-fluid mr-3 h-4" src={activite} alt="building" />
						<p className="h6 text-uppercase font-weight-bold my-auto">En activite</p>
					</div>
					<div className={"block flex-row align-items-center" + (relocationDeclaration?.professionalSituation?.includes(ProfessionOptions.retired) ? "" : " o-30")}>
						<img className="img-fluid mr-3 h-4" src={retraite} alt="building" />
						<p className="h6 text-uppercase font-weight-bold my-auto">RETRAITÉ(E)</p>
					</div>
					<div className={"block flex-row align-items-center" + (relocationDeclaration?.professionalSituation?.includes(ProfessionOptions.unemployed) ? "" : " o-30")}>
						<img className="img-fluid mr-3 h-4" src={pole} alt="building" />
						<p className="h6 text-uppercase font-weight-bold my-auto">À FRANCE TRAVAIL</p>
					</div>
					<div className={"block flex-row align-items-center" + (relocationDeclaration?.professionalSituation?.includes(ProfessionOptions.other) ? "" : " o-30")}>
						<img className="img-fluid mr-3 h-4" src={autre} alt="building" />
						<p className="h6 text-uppercase font-weight-bold my-auto">Autre activité</p>
					</div>
					<div className={"block flex-row align-items-center" + (relocationDeclaration?.professionalSituation?.includes(ProfessionOptions.student) ? "" : " o-30")}>
						<img className="img-fluid mr-3 h-4" src={university} alt="building" />
						<p className="h6 text-uppercase font-weight-bold my-auto">Étudiant(e)</p>
					</div>
					<div className={"block flex-row align-items-center" + (relocationDeclaration?.professionalSituation?.includes(ProfessionOptions.none) ? "" : " o-30")}>
						<img className="img-fluid mr-3 h-4" src={home} alt="building" />
						<p className="h6 text-uppercase font-weight-bold my-auto">Sans activité</p>
					</div>
				</div>
			) : (
				<FormSituationPro relocationDeclaration={relocationDeclaration} isLoading={isLoading} userId={userId} setEditMode={setEditMode} getDeclaration={getDeclaration} />
			)}
		</section>
	);
};
